import { ConfigStore, STR_ERRORS } from "../../../Common";
import { getChannelData } from "../GetChannelData";
export function getRequestProps(connName, message) {
    var _a;
    const connectionURL = ConfigStore.config.urls[connName];
    let baseUrl;
    let headerParams = {};
    if (typeof connectionURL === "object") {
        baseUrl = connectionURL.baseUrl;
        headerParams = (_a = connectionURL.headerParams) !== null && _a !== void 0 ? _a : {};
    }
    else {
        baseUrl = connectionURL;
    }
    if (typeof baseUrl === "undefined") {
        throw new Error(STR_ERRORS.InvalidBaseUrl);
    }
    const { channel, method, params, meta } = getChannelData(connName, message);
    if (meta === null || meta === void 0 ? void 0 : meta.requesterId) {
        headerParams["block-id"] = meta.requesterId;
    }
    return {
        baseUrl,
        endpoint: channel,
        method,
        headers: Object.assign({ Authorization: `Bearer ${ConfigStore.config.connections.jwt}` }, headerParams),
        body: undefined,
        params
    };
}
//# sourceMappingURL=GetRequestProps.js.map